//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { ProductDetailsDrawer } from '@campaigns/components/shared/product-details-modal/drawer/ProductDetailsDrawer';
import { ProductDetailsModal } from '@campaigns/components/shared/product-details-modal/modal/ProductDetailsModal';
import { getIsSamplingCampaignsProductSelectionReworkEnabled } from '@campaigns/redux/selectors/getIsSamplingCampaignsProductSelectionReworkEnabled';

// TODO: PD-327788 - Remove this switch and the legacy ProductDetailsModal once
// SamplingCampaignsProductSelectionRework is released to all clients.
export const ProductDetailsPanel = () => {
  const isProductSelectionReworkEnabled = useSelector(
    getIsSamplingCampaignsProductSelectionReworkEnabled,
  );

  return isProductSelectionReworkEnabled ? (
    <ProductDetailsDrawer />
  ) : (
    <ProductDetailsModal />
  );
};
